export class CountryDto {
  countryId: number;
  titleFrancais: string;
  titleAnglais: string;
  pathImage: string;
  urlImage: string;
}
